exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#games-page[data-v-32f2f0b6]{background:#000}", ""]);

// exports
